import { render, staticRenderFns } from "./CustomersAssignToModal.vue?vue&type=template&id=c071a612"
import script from "./CustomersAssignToModal.vue?vue&type=script&lang=js"
export * from "./CustomersAssignToModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports